export default __webpack_public_path__ + "static/media/sinestatus.d6992318.svg";